
import { getCountries, type CountryCode } from 'libphonenumber-js';
const PHONE_COUNTRIES = new Set(getCountries());
export const COUNTRY_COOKIE='AFLORAR_COUNTRY';
export function isCountryCode(value: string | null | undefined): value is CountryCode { return !!value && PHONE_COUNTRIES.has(value as CountryCode); }
export interface MarketSignal { country: string; market: string; currency: string; }
export function marketForCountry(country: string | null): MarketSignal {
  return { country: country || 'BR', market: 'BR', currency: 'BRL' };
}
export function countryDisplayName(country: string, locale: string): string {
  return new Intl.DisplayNames([locale], { type:'region' }).of(country) ?? country;
}
